export const META_PIXEL_ID = '1659703032428376'

type Fbq = ((...args: unknown[]) => void) & {
  callMethod?: (...args: unknown[]) => void
  queue?: unknown[]
  push?: unknown
  loaded?: boolean
  version?: string
}

declare global {
  interface Window {
    fbq?: Fbq
    _fbq?: Fbq
  }
}

let initialized = false

/** Loads the Meta Pixel base code once and fires the initial PageView. */
export function initMetaPixel(pixelId: string = META_PIXEL_ID): void {
  if (typeof window === 'undefined' || initialized) return
  initialized = true

  if (!window.fbq) {
    const fbq: Fbq = function (...args: unknown[]) {
      if (fbq.callMethod) {
        fbq.callMethod.apply(fbq, args)
      } else {
        fbq.queue?.push(args)
      }
    } as Fbq

    fbq.queue = []
    fbq.loaded = true
    fbq.version = '2.0'
    fbq.push = fbq

    window.fbq = fbq
    window._fbq = fbq

    const script = document.createElement('script')
    script.async = true
    script.src = 'https://connect.facebook.net/en_US/fbevents.js'
    document.head.appendChild(script)

    const noscript = document.createElement('noscript')
    const pixelImage = document.createElement('img')
    pixelImage.height = 1
    pixelImage.width = 1
    pixelImage.style.display = 'none'
    pixelImage.alt = ''
    pixelImage.src = `https://www.facebook.com/tr?id=${pixelId}&ev=PageView&noscript=1`
    noscript.appendChild(pixelImage)
    document.body.appendChild(noscript)
  }

  window.fbq?.('init', pixelId)
  window.fbq?.('track', 'PageView')
}

/** Fires a standard Meta Pixel event. */
export function trackMetaEvent(
  event: 'PageView' | 'ViewContent' | 'InitiateCheckout',
  params?: Record<string, unknown>,
): void {
  if (typeof window === 'undefined' || !window.fbq) return
  window.fbq('track', event, params)
}

export const PRODUCT_EVENT_PARAMS = {
  content_name: 'OT Clinical Toolkit',
  content_ids: ['ot-clinical-toolkit'],
  content_type: 'product',
  value: 27,
  currency: 'USD',
}
